<template>
  <div class="iframe-page-layout">
    <slot />
  </div>
</template>
